export function trueInDbHelper(value = '') {
  return ['t', 'true', 'y', 'yes', 'on', '1', true].includes(value);
}
